/** 빌드 create 성공 → 퀴즈 상세로 넘기는 「저장 직후 클래스 연결 권유」 쿼리 키. */
export const QUIZ_SAVED_LINK_NUDGE_QUERY_KEY = 'showClassLinkNudge';

/**
 * 복사로 생긴 사본이면 쿼리 값을 `true` 대신 이 값으로 넘긴다. 빌드 저장(새로 만들기·복제)은 `true` 이고
 * 복제 여부는 기존 `isDuplicate` 쿼리로 가린다. 권유 계측의 `from` 을 상세에서 정하기 위해서다.
 */
export const QUIZ_SAVED_LINK_NUDGE_COPY_VALUE = 'copy';

/**
 * 보드 만들기·복사 → 보드 상세로 넘기는 「클래스 연결 권유」 쿼리 키. 값은 생긴 경로(`create`·`copy`)다.
 * 퀴즈 키와 이름을 나눈다 — 보드 상세는 같은 화면 안에서 복사본으로 이동하므로 키 하나를 따로 지운다.
 */
export const BOARD_SAVED_LINK_NUDGE_QUERY_KEY = 'classLinkNudge';

/**
 * 권유 모달 그림의 등장 애니메이션(8px 위로 뜨며 나타나기, 250ms ease-out).
 * 움직임 줄이기 설정이면 `motion-safe:` 라 애니메이션 없이 바로 보인다.
 */
export const NUDGE_ENTER_CLASS_NAME = 'motion-safe:animate-class-link-card-in';

/** 등장 순서를 정하는 지연. 요소마다 `style` 로 넘긴다. */
export const nudgeEnterDelay = (ms: number) => ({ animationDelay: `${ms}ms` });
